@if (bannersToShow() && bannersToShow().length) {
  <div class="d-flex flex-column gap-big">
    @for (banner of bannersToShow(); track $index) {
      <div class="banner-wrapper">
        @switch (banner.type) {
          @case ('Selected-Merchants') {
            <daily-stores-all-stores-section [selectedStores]="banner.extractedConfig.stores"></daily-stores-all-stores-section>
          }
          @case ('Section-Banner') {
            <common-app-banners-section-type-banner [bannerData]="banner"></common-app-banners-section-type-banner>
          }
          @case ('Promotion-Carousel') {
            @if (banner?.extractedConfig.promotionGroupUuid) {
              <common-promotions-promotion-carousel
                (nothingToShow)="handleNothingToShow($event)"
                [promotionGroupId]="banner.extractedConfig.promotionGroupUuid"
              ></common-promotions-promotion-carousel>
            }
          }
          @case ('Merchant-Carousel') {
            <daily-stores-applet-category-stores
              [title]="banner?.extractedConfig.title"
              [storeType]="banner?.extractedConfig.storeType"
              [category]="banner?.extractedConfig.category"
              [searchKeyword]="banner?.extractedConfig.searchKeyword"
            ></daily-stores-applet-category-stores>
          }
          @case ('Horizontal-Medium-Carousel') {
            <div class="px-plus">
              <common-ui-components-title-summary
                [title]="banner.title"
                [showButton]="false"
                [wrapperClasses]="'mb-small'"
              ></common-ui-components-title-summary>
            </div>
            <common-ui-components-horizontal-scroll [classes]="'pr-plus'">
              @for (slide of banner.slides; track $index) {
                @if (slide.extractedData.image) {
                  <ui-api-image
                    width="100%"
                    [classes]="'radius-plus'"
                    [imageId]="slide.extractedData.image"
                    [width]="banner.extractedConfig.width ? banner.extractedConfig.width + 'px' : '156px'"
                    [height]="banner.extractedConfig.width ? banner.extractedConfig.height + 'px' : '114px'"
                    [skeletonHeight]="banner.extractedConfig.width ? banner.extractedConfig.height + 'px' : '114px'"
                    (click)="handleSlideClick(slide.extractedAction, slide)"
                  ></ui-api-image>
                }
              }
            </common-ui-components-horizontal-scroll>
          }
          @default {
            @if (banner.slides.length === 1) {
              @if (banner.slides[0].slideType === 'product-carousel') {
                @if (getSlideDataItem(banner.slides[0], 'promotionGroupUuid')) {
                  <common-promotions-promotion-carousel
                    (nothingToShow)="handleNothingToShow($event)"
                    [promotionGroupId]="getSlideDataItem(banner.slides[0], 'promotionGroupUuid')!"
                  ></common-promotions-promotion-carousel>
                }
              } @else if (banner.slides[0].extractedData.image) {
                <div [class]="singleBannerClasses()">
                  <ui-api-image
                    width="100%"
                    [imageId]="banner.slides[0].extractedData.image"
                    (click)="handleSlideClick(banner.slides[0].extractedAction, banner.slides[0])"
                    [skeletonHeight]="'144px'"
                  ></ui-api-image>
                </div>
              }
            } @else if (banner.slides.length > 1) {
              <ngx-carousel
                [mode]="'CARD'"
                [visibleItemCount]="1"
                [index]="0"
                [centerMode]="true"
                [showNavigation]="true"
                [showButtons]="false"
                [isFixedGap]="true"
                [fixedGap]="carouselGap()"
                [changeStepThresholdPercentage]="20"
                [swipeThreshold]="100"
                [disableNavigationDots]="true"
                [disableScaling]="true"
                [enableAutoPlay]="true"
                [autoPlayDurationMillis]="5000"
                (singleTapped)="handleSlideClick(banner.slides[carouselIndex()].extractedAction, banner.slides[carouselIndex()])"
                (indexChange)="handleCarouselIndexChange($event)"
                (isAnimationRunning)="handleAnimationRunning($event)"
              >
                @for (slide of banner.slides; track $index) {
                  <div
                    ngxCarouselSlide
                    class="d-flex justify-content-center align-items-center w-100"
                  >
                    @if (banner.slides[0].slideType === 'product-carousel') {
                      @if (getSlideDataItem(banner.slides[0], 'promotionGroupUuid')) {
                        <common-promotions-promotion-carousel
                          (nothingToShow)="handleNothingToShow($event)"
                          [promotionGroupId]="getSlideDataItem(banner.slides[0], 'promotionGroupUuid')!"
                        ></common-promotions-promotion-carousel>
                      }
                    } @else if (banner.slides[0].extractedData.image) {
                      <ui-api-image
                        width="100%"
                        [imageId]="slide.extractedData.image"
                        [skeletonHeight]="'144px'"
                      ></ui-api-image>
                    }
                  </div>
                }
              </ngx-carousel>
            }
          }
        }
      </div>
    }
  </div>
}
